const initialiseSearch = (searchPageData, quickViewConfig) => {
    mountSearchPage(searchPageData, document.getElementById("search-result"));

    const openQuickView = (detail) => {
        const quickViewElement = document.getElementById("quick-view");
        document.dispatchEvent(
            new CustomEvent("qv_openQuickView", {
                detail: { ...quickViewConfig, ...detail, quickViewElement },
            })
        );
        dispatchCustomEvent(
            { getAttribute: () => "overlayLoad" },
            {
                content: {
                    overlayName: "browser side overlay",
                },
            }
        );
    };

    const handleStrartFreeTrial = (detail, location) => {
        dispatchCustomEvent(
            { getAttribute: () => "searchResultStartFreeTrial" },
            {
                links: {
                    linkCategory: "search page",
                    linkSection: "try for free",
                    linkName: "start free trial",
                    linkType: "button",
                },
                search: {
                    searchType: "inline",
                    inlineSearchTerm: detail.data.eventData.inlineSearchTerm,
                    inlineSearchType: detail.data.eventData.inlineSearchType,
                    inlineSearchResultTerm:
                        detail.data.eventData.inlineSearchResultTerm,
                    inlineSearchCategory: "N/A",
                    inlineSearchCatVal: "N/A",
                    inlineSearchResultClicked: detail.data.font_data.name,
                    inlineSearchResultClickPos:
                        detail.data.eventData.positions[0].toString(),
                },
                font: [
                    {
                        fontID: detail.data.family_id,
                        fontfamily: detail.data.name,
                        fontFoundry: detail.data.foundry_name,
                        fontSource:
                            detail.data.foundry_name === "Monotype"
                                ? "Monotype Fonts"
                                : "Imported Fonts",
                        fontStyleID:
                            detail.data.font_data.pim_style_id || "N/A",
                        fontActionLocation:
                            "inline search result : " + location,
                    },
                ],
            }
        );
        startFreeTrial();
    };

    // main card events
    document.addEventListener("gs_fontNameClick", ({ detail }) => {
        dispatchCustomEvent(
            { getAttribute: () => "searchResultClick" },
            {
                search: {
                    searchType: "inline",
                    inlineSearchTerm: detail.data.eventData.inlineSearchTerm,
                    inlineSearchType: detail.data.eventData.inlineSearchType,
                    inlineSearchResultTerm:
                        detail.data.eventData.inlineSearchResultTerm,
                    inlineSearchCategory: "N/A",
                    inlineSearchCatVal: "N/A",
                    inlineSearchResultClicked: detail.data.font_data.name,
                    inlineSearchResultClickPos:
                        detail.data.eventData.positions[0].toString(),
                },
                font: [
                    {
                        fontID: detail.data.family_id,
                        fontfamily: detail.data.name,
                        fontFoundry: detail.data.foundry_name,
                        fontSource:
                            detail.data.foundry_name === "Monotype"
                                ? "Monotype Fonts"
                                : "Imported Fonts",
                        fontStyleID:
                            detail.data.font_data.pim_style_id || "N/A",
                        fontActionLocation: "inline search result : font name",
                    },
                ],
            }
        );
        openQuickView(detail);
    });
    document.addEventListener("gs_fontStyleClick", ({ detail }) => {
        dispatchCustomEvent(
            { getAttribute: () => "searchResultClick" },
            {
                search: {
                    searchType: "inline",
                    inlineSearchTerm: detail.data.eventData.inlineSearchTerm,
                    inlineSearchType: detail.data.eventData.inlineSearchType,
                    inlineSearchResultTerm:
                        detail.data.eventData.inlineSearchResultTerm,
                    inlineSearchCategory: "N/A",
                    inlineSearchCatVal: "N/A",
                    inlineSearchResultClicked: detail.data.font_data.name,
                    inlineSearchResultClickPos:
                        detail.data.eventData.positions[0].toString(),
                },
                font: [
                    {
                        fontID: detail.data.family_id,
                        fontfamily: detail.data.name,
                        fontFoundry: detail.data.foundry_name,
                        fontSource:
                            detail.data.foundry_name === "Monotype"
                                ? "Monotype Fonts"
                                : "Imported Fonts",
                        fontStyleID:
                            detail.data.font_data.pim_style_id || "N/A",
                        fontActionLocation: "inline search result : styles",
                    },
                ],
            }
        );
        openQuickView(detail);
    });
    // document.addEventListener('gs_foundaryTitleClick', ({ detail }) => {
    //   dispatchCustomEvent({getAttribute: () => 'searchResultClick'}, {
    //     search: {
    //       searchType: "inline",
    //       inlineSearchTerm: detail.data.eventData.inlineSearchTerm,
    //       inlineSearchType: detail.data.eventData.inlineSearchType,
    //       inlineSearchResultTerm: detail.data.eventData.inlineSearchResultTerm,
    //       inlineSearchCategory:"N/A",
    //       inlineSearchCatVal:"N/A",
    //       inlineSearchResultClicked: detail.data.font_data.name,
    //       inlineSearchResultClickPos: detail.data.eventData.positions[0].toString(),
    //     },
    //    font: [{
    //       fontID: detail.data.family_id,
    //       fontfamily: detail.data.name,
    //       fontFoundry: detail.data.foundry_name,
    //       fontSource: detail.data.foundry_name === "Monotype" ? "Monotype Fonts" : "Imported Fonts",
    //       fontStyleID: detail.data.font_data.pim_style_id || "N/A",
    //       fontActionLocation: "inline search result : foundary",
    //   }]
    //   });
    //   openQuickView(detail);
    // });
    document.addEventListener("gs_fontCardClick", ({ detail }) => {
        dispatchCustomEvent(
            { getAttribute: () => "searchResultClick" },
            {
                search: {
                    searchType: "inline",
                    inlineSearchTerm: detail.data.eventData.inlineSearchTerm,
                    inlineSearchType: detail.data.eventData.inlineSearchType,
                    inlineSearchResultTerm:
                        detail.data.eventData.inlineSearchResultTerm,
                    inlineSearchCategory: "N/A",
                    inlineSearchCatVal: "N/A",
                    inlineSearchResultClicked: detail.data.font_data.name,
                    inlineSearchResultClickPos:
                        detail.data.eventData.positions[0].toString(),
                },
                font: [
                    {
                        fontID: detail.data.family_id,
                        fontfamily: detail.data.name,
                        fontFoundry: detail.data.foundry_name,
                        fontSource:
                            detail.data.foundry_name === "Monotype"
                                ? "Monotype Fonts"
                                : "Imported Fonts",
                        fontStyleID:
                            detail.data.font_data.pim_style_id || "N/A",
                        fontActionLocation:
                            "inline search result : card slider",
                    },
                ],
            }
        );
        openQuickView(detail);
    });
    document.addEventListener("gs_getThisFontClick", ({ detail }) => {
        if (isLoggedIn) {
            dispatchCustomEvent(
                { getAttribute: () => "searchResultBuyLicense" },
                {
                    search: {
                        searchType: "inline",
                        inlineSearchTerm:
                            detail.data.eventData.inlineSearchTerm,
                        inlineSearchType:
                            detail.data.eventData.inlineSearchType,
                        inlineSearchResultTerm:
                            detail.data.eventData.inlineSearchResultTerm,
                        inlineSearchResultClicked: detail.data.font_data.name,
                        inlineSearchResultClickPos:
                            detail.data.eventData.positions[0].toString(),
                    },
                    font: [
                        {
                            fontID: detail.data.family_id,
                            fontfamily: detail.data.name,
                            fontFoundry: detail.data.foundry_name,
                            fontSource:
                                detail.data.foundry_name === "Monotype"
                                    ? "Monotype Fonts"
                                    : "Imported Fonts",
                            fontActionLocation:
                                "inline search result : card slider",
                            fontStyleID:
                                detail.data.font_data.pim_style_id || "N/A",
                        },
                    ],
                }
            );
            window.open(
                `${window.location.protocol}//${window.location.host}${currentLocale === "pt"?"/pt":""}/pages/content/plans`,
                "_blank"
            );
        } else {
            handleStrartFreeTrial(detail, "card slider");
        }
    });

    // quick view events
    document.addEventListener("qv_fontCardClick", ({ detail }) => {
        dispatchCustomEvent(
            { getAttribute: () => "searchResultClickOverlay" },
            {
                search: {
                    searchType: "inline",
                    inlineSearchTerm: "",
                    inlineSearchType: "",
                    inlineSearchResultTerm: "",
                    inlineSearchResultClicked: detail.data.font_data.name,
                    inlineSearchResultClickPos:
                        detail.data.eventData.positions[0].toString(),
                },
                font: [
                    {
                        fontID: detail.data.family_id,
                        fontfamily: detail.data.name,
                        fontFoundry: detail.data.foundry_name,
                        fontSource:
                            detail.data.foundry_name === "Monotype"
                                ? "Monotype Fonts"
                                : "Imported Fonts",
                        fontActionLocation:
                            "inline search result : side overlay",
                        fontStyleID:
                            detail.data.font_data.pim_style_id || "N/A",
                    },
                ],
            }
        );
        window.open(
            `${window.location.protocol}//${window.location.host}${Shopify.locale === 'pt-BR'?"/pt":""}/pages/content/plans`,
            "_blank"
        );
    });
    document.addEventListener("qv_getThisFontClick", ({ detail }) => {
        handleStrartFreeTrial(detail, "side overlay");
    });
    document.addEventListener("qv_getThisFontClickFamily", ({ detail }) => {
        handleStrartFreeTrial(detail, "side overlay");
    });
    document.addEventListener("qv_familyDetails", ({ detail }) => {
        if (isLoggedIn) {
            dispatchCustomEvent(
                { getAttribute: () => "searchResultBuyLicense" },
                {
                    search: {
                        searchType: "inline",
                        inlineSearchTerm:
                            detail.data.eventData.inlineSearchTerm,
                        inlineSearchType:
                            detail.data.eventData.inlineSearchType,
                        inlineSearchResultTerm:
                            detail.data.eventData.inlineSearchResultTerm,
                        inlineSearchResultClicked: detail.data.font_data.name,
                        inlineSearchResultClickPos:
                            detail.data.eventData.positions[0].toString(),
                    },
                    font: [
                        {
                            fontID: detail.data.family_id,
                            fontfamily: detail.data.name,
                            fontFoundry: detail.data.foundry_name,
                            fontSource:
                                detail.data.foundry_name === "Monotype"
                                    ? "Monotype Fonts"
                                    : "Imported Fonts",
                            fontActionLocation:
                                "inline search result : side overlay",
                            fontStyleID:
                                detail.data.font_data.pim_style_id || "N/A",
                        },
                    ],
                }
            );
            window.open(
                `${window.location.protocol}//${window.location.host}${Shopify.locale === 'pt-BR'?"/pt":""}/pages/content/plans`,
                "_blank"
            );
        } else {
            handleStrartFreeTrial(detail, "side overlay");
        }
    });
    document.addEventListener("qv_getThisFontClick", ({ detail }) => {
        if (isLoggedIn) {
            window.open(
                `${window.location.protocol}//${window.location.host}${Shopify.locale === 'pt-BR'?"/pt":""}/pages/content/plans`,
                "_blank"
            );
        } else {
            handleStrartFreeTrial(detail, "side overlay");
        }
    });

    // render overload to hide quick view button
    document.addEventListener("qv_onRenderActionIconSection", ({ detail }) => {
        detail.data.forEach((item) => {
            const div = document.getElementById(`${item.bindingElementId}`);
            if (div) {
                div.style.display = "none";
            }
        });
    });
    // render overload to hide quick view button
    document.addEventListener("qv_onRenderActionCTASection", ({ detail }) => {
        detail.data.forEach((item) => {
            const div = document.getElementById(`${item.bindingElementId}`);
            if (div) {
                div.style.display = "none";
            }
        });
    });

    document.addEventListener(
        "gs_onRenderMultipleSelectionSection",
        ({ detail }) => {
            const div = $("#multi-selection");
            if (div) {
                div.each(function () {
                    let multiSelectionElement = document.createElement("div");
                    let imageeElement = document.createElement("img");
                    imageeElement.src =
                        "https://cdn.shopify.com/s/files/1/0555/5929/1039/files/favicon.png?v=1618399012";
                    imageeElement.alt = "Monotypefonts Logo";
                    imageeElement.style.marginRight = "10px";
                    imageeElement.style.marginTop = "1px";
                    imageeElement.style.float = "left";
                    imageeElement.style.height = "16px";
                    imageeElement.style.width = "16px";
                    imageeElement.style.borderRadius = "2px";

                    multiSelectionElement.appendChild(imageeElement);
                    if (locale === "en") {
                        multiSelectionElement.innerHTML +=
                            "All fonts available with subscription";
                    } else if (locale === "de") {
                        multiSelectionElement.innerHTML +=
                            "Alle Schriften verfügbar mit Abonnement";
                    } else if (locale === "fr") {
                        multiSelectionElement.innerHTML +=
                            "Toutes les polices disponibles avec abonnement";
                    } else if (locale === "es") {
                        multiSelectionElement.innerHTML +=
                            "Todas las fuentes disponibles con suscripción";
                    }else if (locale === "pt") {
                        multiSelectionElement.innerHTML +=
                            "Todas as fontes disponíveis com assinatura";
                    }

                    multiSelectionElement.style.backgroundColor = "#E7EAEE";
                    multiSelectionElement.style.borderRadius = "8px";
                    multiSelectionElement.style.opacity = "0px";
                    multiSelectionElement.style.padding = "8px 11px 8px 11px";
                    multiSelectionElement.style.fontWeight = "500";
                    multiSelectionElement.style.fontSize = "13px";
                    multiSelectionElement.style.color = "#1E242C";
                    multiSelectionElement.style.height = "#32px";
                    multiSelectionElement.style.width = "#273px";
                    multiSelectionElement.style.fontFamily =
                        "var(--ff-h-mt-text-md)";
                    
                    multiSelectionElement.style.mask= "linear-gradient(90deg, rgb(0, 0, 0) 50%, rgba(0, 0, 0, 0.333), rgb(0, 0, 0) 70%) right center / 300% 100%";
                    multiSelectionElement.style.animation= "shimmer 6s infinite"; 

                    // this.classList.add("shimmer");
                    this.replaceChild(multiSelectionElement, this.firstChild);
                });
            }
        }
    );
};
